import { MigrateFunctionBuilder } from '@salsita-ai/platform-project-sdk/domain';
import { modelVersion as adminModelVersion, modelVersions as adminModelVersions } from '../__generated/admin-model/index.js';
import { migrateToV2 } from './v02.js';
import { migrateToV3 } from './v03.js';
export const migrations = {
    2: migrateToV2,
    3: migrateToV3
};
export const migrateAdminState = MigrateFunctionBuilder.fromVersions(adminModelVersions).to(adminModelVersion).using(migrations).build();

//# sourceMappingURL=index.js.map